module.exports = __webpack_public_path__ + "static/media/01activos.cdc6825.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/01activos.mp4
// module id = 716
// module chunks = 1